export default "__VITE_ASSET__CZOYco7m__"